export default __webpack_public_path__ + "static/media/rounded-back.9efca9fc.webp";